import { createMutation } from '@tanstack/svelte-query';
import { createDINChannel, deleteDINChannel, patchDINChannel } from '$lib/api/din_channel';
import { invalidateAfterChannelCreate, invalidateAfterChannelDelete, invalidateAfterChannelPatch } from '$lib/state/invalidation';
import { getUnitScope, resolveScope, type ScopeFn } from '$lib/queries/scope';
import type { DINChannelResponse } from '$lib/types/din_channel';
import type { DINChannelPatch } from '$lib/types/din_channel';

export const createDINChannelMutation = (scope: ScopeFn = getUnitScope()) =>
  createMutation<DINChannelResponse, Error, { din_module: number; channel_number: number; load?: number | null }>(() => ({
    mutationFn: (request) => createDINChannel(request),
    onSuccess: () => invalidateAfterChannelCreate(resolveScope(scope))
  }));

export const deleteDINChannelMutation = (scope: ScopeFn = getUnitScope()) =>
  createMutation<void, Error, number>(() => ({
    mutationFn: (id) => deleteDINChannel(id),
    onSuccess: () => invalidateAfterChannelDelete(resolveScope(scope))
  }));

export const patchDINChannelMutation = (scope: ScopeFn = getUnitScope()) =>
  createMutation<unknown, Error, { id: number; patch: DINChannelPatch }>(() => ({
    mutationFn: ({ id, patch }) => patchDINChannel(id, patch),
    onSuccess: () => invalidateAfterChannelPatch(resolveScope(scope))
  }));
